<p>
  loading-section works!
</p>
